import {Component, ChangeDetectorRef, OnInit} from '@angular/core';
import {FormBuilder, FormGroup} from '@angular/forms';
import moment from 'moment';
import {BehaviorSubject, Observable} from 'rxjs';
import {map, takeUntil} from 'rxjs/operators';
import {AssigneeService} from '../../../requests/services/assignee.service';
import {RequestsService} from '../../../requests/services/requests.service';
import {ItemListProvider, MultiSelectSearchDropdownOption} from '../../../shared/components/multiselect-search-dropdown/item-list.provider';
import {UserModel} from '../../../shared/models/user.model';
import {UtilsService} from '../../../shared/services/utils.service';
import {WithDestroy} from '../../../shared/components/with-destroy/with-destroy.mixin';

class ListDataSource extends ItemListProvider {
  constructor(private userService: AssigneeService) {
    super();
  }

  private makeLabel(user: UserModel) {
    return [user.firstName, user.lastName].filter(v => v).join(' ');
  }

  loadValues(values: string[]): Observable<MultiSelectSearchDropdownOption[]> {
    return this.userService.loadValues(values).pipe(map(users => users.map(user => ({label: this.makeLabel(user), value: user.userName}))));
  }
  searchValues(query: string): Observable<MultiSelectSearchDropdownOption[]> {
    return this.userService
      .searchValues(query)
      .pipe(map(users => users.map(user => ({label: this.makeLabel(user), value: user.userName}))));
  }
  searchUsers(query: string): Observable<UserModel[]> {
    return this.userService.searchValues(query).pipe(map(users => users));
  }
}

@Component({
  selector: 'app-features',
  templateUrl: './features.component.html',
  styleUrls: []
})
export class FeaturesComponent extends WithDestroy() implements OnInit {
  form: FormGroup;
  isLoading$ = new BehaviorSubject(false);
  merchantSearch = [];
  public userListProvider: ListDataSource;
  public userSearch: any = [];
  isUserLoading = new BehaviorSubject<boolean>(false);

  constructor(
    private fb: FormBuilder,
    private requestsService: RequestsService,
    private cd: ChangeDetectorRef,
    private utilsService: UtilsService,
    private assigneeService: AssigneeService
  ) {
    super();
    this.form = this.fb.group({
      checkbox: this.fb.control(false),
      currency: this.fb.control(100.01),
      deliveryDate: this.fb.control(moment().subtract(10, 'days')),
      dateRange: this.fb.control({from: moment().subtract(10, 'days'), to: moment()}),
      textInput: this.fb.control('Text input'),
      numberInput: this.fb.control(321312),
      chips: this.fb.control(['1000', '2000']),
      httpSearchDropdown: this.fb.control(null),
      httpSearchDropdownMultiple: this.fb.control([]),
      dropdown: this.fb.control(null),
      dropdownMultiple: this.fb.control(null),
      percent: this.fb.control(0.05),
      richText: this.fb.control('<a href="javascript: alert(\'Hi!\')">Rich Text</a>'),
      text: this.fb.control('<a href="javascript: alert(\'Hi!\')">Rich Text</a>'),
      radioGroup: this.fb.control(true)
    });
    this.userListProvider = new ListDataSource(this.assigneeService);
  }
  ngOnInit(): void {
    this.form
      .get('text')
      .valueChanges.pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe(v => this.form.get('richText').setValue(v, {emitEvent: false}));
    this.form
      .get('richText')
      .valueChanges.pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe(v => this.form.get('text').setValue(v, {emitEvent: false}));
  }

  public getMerchants(name: string): void {
    this.isLoading$.next(true);
    this.requestsService.getMerchants(name).subscribe(
      (data: Array<{id: number; name: string}>) => {
        this.isLoading$.next(false);
        this.merchantSearch = [...data];
        this.cd.detectChanges();
      },
      error => {}
    );
  }
  public getMerchantLabel(option): string {
    return option.name;
  }

  public getUserLabel(user: UserModel): string {
    return [user.firstName, user.lastName].filter(v => v).join(' ');
  }

  public getUsers(name: string): void {
    this.isUserLoading.next(true);
    this.userListProvider.searchUsers(name).subscribe(
      data => {
        this.userSearch = data;
        this.cd.detectChanges();
        this.isUserLoading.next(false);
      },
      () => {
        this.isUserLoading.next(false);
      }
    );
  }
}
